<template>
  <el-upload
    drag
    action="/oss/ossUploadReturnUrlAndFileId"
    :auto-upload="false"
    :on-change="onFileChange"
    style="width:100%"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">
      将文件拖到此处，或
      <em>点击上传</em>
    </div>
  </el-upload>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {}
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    onFileChange(file) {
      if (file.status === 'ready') {
        this.push({
          file: file.raw,
          params: {
            callback: 'abs.plat.project.doc.upload.callback',
            data: {},
            uptype: 'part',
          },
          added: ({ md5, suffix }) => {
            let code = md5 + '.' + suffix
            console.log(code)
          },
        })
      }
    },
  },
}
</script>
